// extracted by mini-css-extract-plugin
export default {"gridLayout":"layout_gridLayout__59pMZ","containerGeral":"layout_containerGeral__TOalh"};